import { CURRENT_TENANT } from "@/constants/tenant";

export const tenant = CURRENT_TENANT;
export const baseURL = tenant === "app" ?
    process.env.BARESTO_PROTOCOL + '://' + process.env.BARESTO_API + '/' :
    process.env.BARESTO_PROTOCOL + '://' + tenant + '.' + process.env.BARESTO_API + '/';

export const getBaseURL = () => baseURL;


// WEBPACK FOOTER //
// ./src/helpers/tenant.js